// src/components/farm/FarmCard.jsx
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import FarmCardStyle from "../../assets/stylesheets/FarmCard.module.css";
import SkeletonCard from '../common/SkeletonCard';

import Logger from "../../utils/logger";

const log = Logger.create("FarmCard");

export default function FarmCard({
  farm,
  index,
  onImageLoaded,
  onClick,
  loading,
  variant
}) {
  const [imageLoaded, setImageLoaded] = useState(false);
  
  // Get cover image URL from farm data or use fallback
  const coverUrl = farm.coverImage?.viewUrl || "/assets-placeholder/no-image.png";

  // Image preload
  useEffect(() => {
    if (!coverUrl) return;
    
    const img = new Image();
    img.src = coverUrl;
    img.onload = () => {
      setImageLoaded(true);
      onImageLoaded?.(index);
    };
    img.onerror = () => {
      setImageLoaded(true);
      onImageLoaded?.(index);
    };
    
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [coverUrl, index, onImageLoaded]);

  // Loading state
  if (!imageLoaded) {
    return <SkeletonCard />;
  }

  // After loading
  return (
    <div className={FarmCardStyle["event-card"]} onClick={onClick}>
      <div className={FarmCardStyle["event-card-image-container"]}>
          {farm.banner && (
            <div className={`${FarmCardStyle["card-badge"]}`}>
              {farm.banner}
            </div>
          )}

        <img
          src={coverUrl}
          alt={farm.name}
          className={FarmCardStyle["event-card-image"]}
        />
      </div>
      <h3 className={
        variant === "list"
          ? FarmCardStyle["list-event-card-title"]
          : FarmCardStyle["event-card-title"]
      }>
        {farm.name}
      </h3>
      <p className={
        variant === "list"
          ? FarmCardStyle["list-event-card-location"]
          : FarmCardStyle["event-card-location"]
      }>
        {farm.location?.address?.city  || "Unknown city"},&nbsp;
        {farm.location?.address?.state || "Unknown state"}      
      </p>
    </div>
  );
}

FarmCard.propTypes = {
  farm: PropTypes.shape({
    id:       PropTypes.number.isRequired,
    name:     PropTypes.string.isRequired,
    banner:   PropTypes.string,
    coverImage: PropTypes.shape({
      viewUrl: PropTypes.string,
    }),
    location: PropTypes.shape({
      address: PropTypes.shape({
        city:  PropTypes.string,
        state: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  index:          PropTypes.number,
  onImageLoaded:  PropTypes.func,
  onClick:        PropTypes.func,
  variant: PropTypes.string // 'list'면 list 스타일 사용
};
